<ion-header *ngIf="headerIsHidden" no-border>
  <app-close-button></app-close-button>
</ion-header>

<ion-content>
  <div class="wide">
    <app-detail-header [headerData]="headerData"></app-detail-header>
    <app-detail-controls [headerData]="headerData"></app-detail-controls>

    <!-- <app-closing-notes *ngIf="closingData.closeNotes" [closingData]="closingData"></app-closing-notes> -->
    <app-closing-details [scrollRef]="historyRef" *ngIf="closingData.closeNotes" [closingData]="closingData"></app-closing-details>

    <!-- IMAGES BLOCK-->
    <div class="detail-page-section">
      <div class="headline-medium">{{ "DASHPAGES.CONDITION_DETAIL_headline_medium" | translate }}</div>
      <image-gallery-modal [inputImages]="images"></image-gallery-modal>
      <app-asset-status-panel [observation]="observation"></app-asset-status-panel>
      <hr class="hr-dashed">
    </div>
    <!-- IMAGES BLOCK END-->

    <!-- PROPERTY VALUES BLOCK-->
    <div class="detail-page-section" *ngIf="observationDetailService.hasCollectedProperties(observation, 'new')">
      <div class="headline-medium">{{ "SHARED.Collected_Property_Values" | translate }}</div>
      <app-property-values-display 
        [observation]="observation"
        [displayState]="'new'">
      </app-property-values-display>
      <hr class="hr-dashed">
    </div>
    <!-- PROPERTY VALUES BLOCK END-->

    <!-- PROPERTY VALUES BLOCK-->
    <div class="detail-page-section" *ngIf="observationDetailService.hasCollectedProperties(observation, 'fix')">
      <div class="headline-medium">{{ "SHARED.Fix_Property_Values" | translate }}</div>
      <app-property-values-display 
        [observation]="observation"
        [displayState]="'fix'">
      </app-property-values-display>
      <hr class="hr-dashed">
    </div>
    <!-- FIX PROPERTY VALUES BLOCK END-->

    <!-- NOTE BLOCK-->
    <div class="detail-page-section">
      <div class="headline-medium">{{ "SHARED.Observation_Notes" | translate }}</div>

      <div class="section-grid">
        <!--NEW OBSERVATION NOTES-->
        <div class="section-grid-left">
          <div class="observation-notes-header">
            <span class="observation-notes-subhead subhead-open" id="noteColorCode">
            {{ "SHARED.Open" | translate }}
            </span>
            <ion-button (click)="addOpenNote()" [appAccountCanViewExcept]="['viewer']" class="page-button smaller"
                        color="secondary">
              {{ "SHARED.Add_Note" | translate }}
            </ion-button>
          </div>
          <div class="observation-notes-body">
            <ul class="notes-list" id="observationNotes">
              <li *ngFor="let note of notes.openNotes; let last = last" [last]="last" appMarkNote>
                <app-note-list-item [note]="note"></app-note-list-item>
              </li>
            </ul>
          </div>
        </div>

        <!--FIXED OBSERVATION NOTES-->
        <div *ngIf="notes.displayClosedNotes" class="section-grid-right">
          <div class="observation-notes-header">
            <span class="observation-notes-subhead subhead-fixed">Fixed</span>
            <ion-button (click)="addClosedNote()" [appAccountCanViewExcept]="['viewer']" class="page-button smaller"
                        color="secondary">
              {{ "SHARED.Add_Note" | translate }}
            </ion-button>
          </div>
          <div class="observation-notes-body">
            <ul class="notes-list" id="observationNotes">
              <li *ngFor="let note of notes.closedNotes; let last = last" [last]="last" appMarkNote>
                <app-note-list-item [note]="note"></app-note-list-item>
              </li>
            </ul>
          </div>

        </div>
      </div>

      <hr class="hr-dashed">

    </div>
    <!-- NOTE BLOCK END-->

    <!--OBSERTVATION HISTORY-->
    <div #historyRef>
      <app-observation-history [observationId]="oid" [title]="'SHARED.Observation_History'"></app-observation-history>
    </div>

    <!--OBSERTVATION HISTORY END-->
    <!-- <div class="section-grid-footer">
      <app-detail-controls [headerData]="headerData"></app-detail-controls>
    </div> -->
  </div>
</ion-content>

<ion-footer *ngIf="bottomNav" [appAccountCanViewExcept]="['viewer']" no-border transparent>
  <ion-toolbar>
    <app-detail-footer [footerData]="footerData"></app-detail-footer>
  </ion-toolbar>
</ion-footer>
